<template>
    <transition name="vrm-open--vue" mode="out-in">
        <div v-if="open" class="vrm-togglable-panel vrm-open--vue">
            <slot />
        </div>
    </transition>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class VrmHeaderPanel extends Vue {
    @Prop()
    open;
}
</script>
